import { useMutation, useQueryClient } from "@tanstack/react-query";
import { adminCampaignsKeys } from "Api/Queries/Admin/useAdminCampaignsQuery";
import {
  type CreateCampaignRequest,
  type CreateCampaignCommandResult,
  postAdminCampaigns,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Props = {
  onSuccess?: (result: CreateCampaignCommandResult) => void;
  onError?: (error: Error) => void;
};

export const useCreateCampaignMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation<CreateCampaignCommandResult, Error, CreateCampaignRequest>(
    {
      mutationFn: processResponseWithApiProblemDetails(
        (request: CreateCampaignRequest) => postAdminCampaigns(request),
      ),
      onSuccess: (result) => {
        queryClient.invalidateQueries({ queryKey: adminCampaignsKeys.all });
        onSuccess?.(result);
      },
      onError,
    },
  );
};
